
import React from "react";

const DangerIcon = () => {

    return (
      <React.Fragment>
        <div>
            <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.73004 19.0001H20.26C21.03 19.0001 21.51 18.1701 21.13 17.5001L11.86 1.50006C11.47 0.830059 10.51 0.830059 10.13 1.50006L0.860045 17.5001C0.480045 18.1701 0.960045 19.0001 1.73004 19.0001ZM12 16.0001H10V14.0001H12V16.0001ZM11 12.0001C10.45 12.0001 10 11.5501 10 11.0001V9.00006C10 8.45006 10.45 8.00006 11 8.00006C11.55 8.00006 12 8.45006 12 9.00006V11.0001C12 11.5501 11.55 12.0001 11 12.0001Z" fill="#E71D36"/>
            </svg>
        </div>
      </React.Fragment>
    )
}

export default DangerIcon;